export default "__VITE_ASSET__CJCP8zIX__"